<template>
  <div>
    <b-row class="float-left">
      <router-link class="text-left ml-4 mt-1" :to="{ name: 'Tickets' }">
        <b-button pill variant="info"> بازگشت </b-button>
      </router-link>
    </b-row>

    <b-table
      v-bind="tableAttributes"
      :fields="fields"
      :items="metas"
      class="mt-2"
    >
      <template #cell(name)="data">
        {{ data.item.name }}
      </template>
      <template #cell(priority)="data">
        {{ data.item.priority.meta_key }}
      </template>
      <template #cell(status)="data">
        {{ data.item.status.meta_key }}
      </template>
      <template #cell(function)="data">
        {{ data.item.function }}

        <span class="h5" v-b-tooltip.hover title="حذف">
          <b-icon
            icon="trash"
            class="ml-4"
            @click="forceDeleteTicket(data.item)"
          />
        </span>
        <span class="h5" v-b-tooltip.hover title="بازگردانی">
          <b-icon
            icon="arrow-clockwise"
            class="ml-4"
            @click="restoreTicket(data.item)"
          />
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import { tableAttributes } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import { mapGetters } from "vuex";

export default {
  name: "tableItems",

  data() {
    return {
      tableAttributes: { ...tableAttributes, ...{ responsive: "xl" } },
      fields: [
        { key: "name", label: "عنوان" },
        { key: "priority", label: "اولویت" },
        { key: "status", label: "وضعیت" },
        { key: "function", label: "عملیات" },
      ],

      mainProps: { width: 80, height: 80, class: "p-0 rounded" },
    };
  },
  computed: {
    ...mapGetters({
      metas: "Ticket/setTrash",
    }),
  },

  mounted() {
    this.$store.dispatch("Ticket/setTrash");
  },
  methods: {
    forceDeleteTicket(ticket) {
      if (confirm("آیا از حذف دائمی این پیام اطمینان دارید؟")) {
        this.$store.dispatch("Ticket/forceDeleteTicket", ticket);
      }
    },
    restoreTicket(ticket) {
      if (confirm("آیا از بازگردانی این پیام اطمینان دارید؟")) {
        this.$store.dispatch("Ticket/restoreTicket", ticket);
      }
    },
  },
};
</script>